module.exports = __webpack_public_path__ + "static/img/check.b70525d7.png";